const lightPalette = {
  text: {
    primary: '#1A1228',
    secondary: '#7A7096',
    disabled: '#C9C2DC',
  },
  primary: {
    dark: '#1A1228',
    main: '#1A1228',
    light: '#7A7096',
  },
  secondary: {
    dark: '#5A3FB8',
    main: '#7C5CE0',
    light: '#D2B8FF',
    background: '#F0EAFF',
  },
  border: {
    main: '#A89BC4',
    light: '#E4DDF5',
    background: '#F7F4FF',
  },
  error: {
    dark: '#AC2C3B',
    main: '#FF5F72',
    light: '#FFB4BD',
    background: '#FFE6EA',
  },
  success: {
    dark: '#028D4C',
    main: '#00B460',
    light: '#72F5B8',
    background: '#EFFAF1',
  },
  info: {
    dark: '#52BFDC',
    main: '#5FDDFF',
    light: '#B7F0FF',
    background: '#EFFCFF',
  },
  warning: {
    dark: '#C04C32',
    main: '#FF8061',
    light: '#FFBC9F',
    background: '#FFF1E0',
  },
  background: {
    default: '#F7F4FF',
    main: '#F7F4FF',
    paper: '#FFFFFF',
    light: '#F0EAFF',
  },
  backdrop: {
    main: '#7A7096',
  },
  logo: {
    main: '#1A1228',
    background: '#EFE8FF',
  },
  static: {
    main: '#1A1228',
  },
}

export default lightPalette
